//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import KeenSlider from 'keen-slider'
import HomepageSliderGoodScience from '~/components/homepage/HomepageSliderGoodScience'
import HomepageSliderCultBeauty from '~/components/homepage/HomepageSliderCultBeauty'
import HomepageSliderBuy3 from '~/components/homepage/HomepageSliderBuy3'
import HomepageSliderImmunity from '~/components/homepage/HomepageSliderImmunity'
import HomepageSliderNutritionists from '~/components/homepage/HomepageSliderNutritionists'
import HomepageSliderCS from '~/components/homepage/HomepageSliderCS'

export default {
  name: 'HomepageSlider',

  data() {
    return {
      Slider: null,
      details: {},
      interval: null
    }
  },

  computed: {
    slides() {
      return !this.isUK
        ? [
            HomepageSliderGoodScience,
            HomepageSliderBuy3,
            HomepageSliderCS,
            HomepageSliderImmunity,
            HomepageSliderNutritionists
          ]
        : [HomepageSliderCultBeauty, HomepageSliderNutritionists]
    },

    bulletStyle() {
      if (!this.isUK) {
        switch (this.currentSlide) {
          case 0:
          case 2:
            return '--slider-bullet-border:#fff'
          default:
            return '--slider-bullet-border:#333'
        }
      }

      switch (this.currentSlide) {
        case 0:
          return '--slider-bullet-border:#fff'
        default:
          return '--slider-bullet-border:#333'
      }
    },

    currentSlide() {
      return this.details?.relativeSlide
    },

    slideCount() {
      return this.details?.size
    },

    isUK() {
      return this.$store.getters['ui/getHostname'].includes('co.uk')
    }
  },

  mounted() {
    this.Slider = new KeenSlider(this.$refs.slider, {
      loop: true,
      mounted: this.updateDetails,
      slideChanged: this.updateDetails,
      move: () => {
        this.setInterval()
      },
      dragStart: () => {
        this.setPause(true)
      },
      dragEnd: () => {
        this.setPause(false)
      }
    })
    this.setInterval()
  },

  beforeDestroy() {
    if (this.Slider) this.Slider.destroy()
  },

  methods: {
    changeSlide(idx) {
      this.Slider.moveToSlideRelative(idx)
    },

    setPause(active) {
      this.pause = active
      this.setInterval()
    },

    resetInterval() {
      clearInterval(this.interval)
    },

    setInterval() {
      this.resetInterval()
      this.interval = setInterval(() => {
        if (!this.pause) this.Slider.next()
      }, 5000)
    },

    updateDetails(s) {
      this.details = s.details()
    }
  }
}
